import { withStyles } from "@material-ui/core/styles";

const styles = theme => ({});

export default withStyles(styles);
